export default __webpack_public_path__ + "static/media/LO15.a9291ae1.mp3";